import styled from "styled-components";
import bgImg from "./../../images/servicesbg.jpg"
import { Link as LinkR } from "react-router-dom";

export const ServicesContainer = styled.div`
  padding-bottom: 80px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;  /* Center the content horizontally */
  overflow-x: hidden;
  background-image: url(${bgImg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  ${(props) =>
    props.isFilterActive &&
    `
      background-color: rgba(0, 0, 0, 0.5);
      filter: grayscale(100%);
    `}

  @media screen and (max-width: 768px) {
    background-color: #221F3C;
    background-image: none;
  }
`;
export const TopPurpleBanner = styled.div`
  background-color: #221F3C;
  width: 100%;
  padding: 30px;  /* Adjust the padding as needed */
  margin-bottom: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    width: auto;
    padding: 24px;
  }
`;

export const BottomPurpleBanner = styled.div`
  background-color: #221F3C;
  width: 90%;
  padding: 10px;  /* Adjust the padding as needed */
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    width: auto;
    padding: 12px 20px;
  }
`;

export const ServicesWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  justify-content: center;
  gap: 40px;
  padding: 0 20px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 24px;
    padding: 0 16px;
  }
`;

export const ServicesCard = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  height: 320px;
  padding: 40px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
  box-sizing: border-box;
  width: 100%;
  max-width: 320px;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2 ease-in-out;
    cursor: pointer;
  }

  @media screen and (max-width: 768px) {
    height: auto;
    max-width: 100%;
  }

  @media screen and (max-width: 480px) {
    padding: 28px 20px;
  }
`;

export const FeaturedCard = styled(ServicesCard)`
  // border: 2px solid #D3000D;
  // box-shadow: 0 4px 6px rgba(211, 0, 13, 0.3);
`;

export const ServicesButton = styled(LinkR)`
  background: #01bf71;
  text-decoration: none;
  color: #fff;
  border: none;
  padding: 10px 20px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
  border-radius: 15px;

  &:hover {
    background: #D3000D;
    color: #fff;
  }

  @media screen and (max-width: 480px) {
    /* Adjust the button's padding, font size, or any other styles for smaller screens */
    padding: 8px 16px; /* Example padding for smaller screens */
    font-size: 0.9rem; /* Example font size for smaller screens */
  }
`;

export const ServicesIcon = styled.img`
  height: 220px;
  width: 220px;
  margin-bottom: 30px;
  object-fit: contain;

  @media screen and (max-width: 768px) {
    height: 200px;
    width: 200px;
  }

  @media screen and (max-width: 480px) {
    height: 160px;
    width: 160px;
  }
`;
export const ServicesH1 = styled.h1`
  color: #D3000D;
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;  /* Center the text horizontally */

  @media screen and (max-width: 768px) {
    margin-bottom: 10px;
  }
`;

export const ServicesH2 = styled.h2`
  width: 100%;
  max-width: 240px;
  font-size: 1.1rem;
  margin-bottom: 10px;
  color: red;
  text-align: center;
`;

export const ServicesP = styled.p`
  font-size: 1rem;
  text-align: center;
`;
